import * as React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import StudentForm from "./studentForm";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, Autocomplete } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useAcademicYear } from "./AcademicYearContext";
import DownloadIcon from "@mui/icons-material/Download";
import { isComponentSettingEnabled } from "../utility/componentSettingsHelper";
import * as XLSX from "xlsx/xlsx";
import Stack from "@mui/material/Stack";
import "../App.css";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
    cursor: "pointer",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    // backgroundColor: theme.palette.action.hover,
    cursor: "pointer",
  },
  "&:active": {
    backgroundColor: theme.palette.action.selected,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

export default function StudentManagement() {
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  // Picking a grade/section no longer applies it immediately — selectedGrade/
  // selectedSection reflect whatever's currently picked in the dropdowns,
  // but the fetch only uses appliedGradeId/appliedSectionId, which are set
  // (along with the search term) when Go is clicked. That lets search text
  // and grade/section be combined into one filter applied together.
  const [appliedGradeId, setAppliedGradeId] = useState("");
  const [appliedSectionId, setAppliedSectionId] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  // Applied search term — only changes when the user submits it via the Go
  // button or Enter, at which point the fetch effect (which depends on it)
  // fires exactly once for that action.
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [grades, setGrades] = useState([]);
  const [gradeAdmission, setGradeAdmission] = useState([]);
  const [sections, setSections] = useState([]);
  const [feeSlab, setFeeSlab] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "student_id",
    direction: "desc",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  // const [academicYearId, setAcademicYearId] = useState("");
  const [oldPaymentData, setOldPaymentData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeAdmissionName, setGradeAdmissionName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [feesSlabName, setFeesSlabName] = useState("");
  const [userId, setUserId] = useState();
  const [userMail, setUserMail] = useState();
  const [transportFees, setTransportFees] = useState([]);
  const [transportSlab, setTransportSlab] = useState();
  const [loading, setLoading] = useState(false); // Loading state
  const navigate = useNavigate();
  const [downloadUrl, setDownloadUrl] = useState("");
  const [downloadReportEnabled, setDownloadReportEnabled] = useState(false);
  // const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  // const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  // const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  // const [resendCount, setResendCount] = useState(0); // Counter for resend attempts
  // const [resendTimer, setResendTimer] = useState(600);
  // const [canResend, setCanResend] = useState(true);

  //
  const [open, setOpen] = useState(false);
  // const [grades, setGrades] = useState([]);
  // const [gradeAdmission, setGradeAdmission] = useState([]);
  // const [sections, setSections] = useState([]);
  const [formData, setFormData] = useState({ rte: false });
  // const [addressData, setAddressData] = useState([]);
  // const [feeSlab, setFeeSlab] = useState([]);
  // const [transportFees, setTransportFees] = useState([]);
  const [years, setYears] = useState([]);
  const [emailError, setEmailError] = useState("");
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [borderColor, setBorderColor] = useState("#0A64A2");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [genderError, setGenderError] = useState(false);
  const [feeSlabError, setFeeSlabError] = useState(false);
  const [gradeError, setGradeError] = useState(false);
  const [mobileNoError, setMobileNoError] = useState(false);
  const currentYear = new Date().getFullYear();
  const today = new Date().toISOString().split("T")[0];
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  // const [email, setEmail] = useState(process.env.REACT_APP_EMAIL);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1); // Counter for resend attempts
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [addressFlag1, setAddressFlag1] = useState(false);
  const [addressFlag2, setAddressFlag2] = useState(false);
  const [addressFlag3, setAddressFlag3] = useState(false);
  const [documentFlag1, setDocumentFlag1] = useState(false);
  const [documentFlag2, setDocumentFlag2] = useState(false);
  const [documentFlag3, setDocumentFlag3] = useState(false);
  const [documentFlag4, setDocumentFlag4] = useState(false);
  const [documentFlag5, setDocumentFlag5] = useState(false);
  const [documentFlag6, setDocumentFlag6] = useState(false);
  const [documentFlag7, setDocumentFlag7] = useState(false);
  const [documentFlag8, setDocumentFlag8] = useState(false);
  const [documentFlag9, setDocumentFlag9] = useState(false);
  const [documentFlag10, setDocumentFlag10] = useState(false);
  const [documentFlag11, setDocumentFlag11] = useState(false);
  const [selectedGradeName, setSelectedGradeName] = useState();
  const [selectedGradeAdmissionName, setSelectedGradeAdmissionName] =
    useState();
  const [selectedSectionName, setSelectedSectionName] = useState();
  const [selectedFeesSlabName, setSelectedFeesSlabName] = useState();
  const [selectedTransportSlab, setSelectedTransportSlab] = useState();
  const studentCache = React.useRef(new Map());
  const gradeMap = React.useRef(new Map());
  const sectionMap = React.useRef(new Map());
  const feesSlabMap = React.useRef(new Map());
  const transportMap = React.useRef(new Map());

  const { academicYearId } = useAcademicYear();
   const instituteId = localStorage.getItem("instituteId");
  const instituteEmailMap = {
    "1": process.env.REACT_APP_EMAIL_JHS,
    "2": process.env.REACT_APP_EMAIL_JPS,
  };
  const [email, setEmail] = useState(instituteEmailMap[instituteId]);

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  useEffect(() => {
    const loadDownloadReportSetting = () => {
      isComponentSettingEnabled("StudentManagement", "Download Report").then(
        setDownloadReportEnabled,
      );
    };

    loadDownloadReportSetting();

    window.addEventListener("instituteChanged", loadDownloadReportSetting);
    return () => {
      window.removeEventListener(
        "instituteChanged",
        loadDownloadReportSetting,
      );
    };
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          setUserMail(response.data.user.email_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

useEffect(() => {
  Promise.all([
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + "/grade/grade-section"),
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/getFeeSlab"),
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + "/transportPayment/transportSlab"),
  ]).then(([gradeRes, feeRes, transportRes]) => {

    // ── setStates first ──
    setGrades(gradeRes.data.grades);
    setGradeAdmission(gradeRes.data.grades);
    setSections(
      gradeRes.data.sections.sort((a, b) =>
        a.section_name.localeCompare(b.section_name)
      )
    );
    setFeeSlab(
      feeRes.data.sort((a, b) =>
        a.fees_slab.localeCompare(b.fees_slab, undefined, { numeric: true, sensitivity: "base" })
      )
    );
    setTransportFees(
      transportRes.data.sort((a, b) =>
        a.transport_slab_name.localeCompare(b.transport_slab_name, undefined, { numeric: true, sensitivity: "base" })
      )
    );

    // ── then build lookup Maps right below ──
    gradeRes.data.grades.forEach(g => gradeMap.current.set(g.grade_id, g.grade_name));
    gradeRes.data.sections.forEach(s => sectionMap.current.set(s.section_id, s.section_name));
    feeRes.data.forEach(f => feesSlabMap.current.set(f.fees_slab_id, f.fees_slab));
    transportRes.data.forEach(t => transportMap.current.set(t.transport_slab_id, t.transport_slab_name));

  }).catch((error) => {
    if (error.response && error.response.status === 401) navigate("/signin");
    else console.error("Error fetching lookup data:", error);
  });
}, []);
  //Done by simran. created handle submit function for snackbar
  // const handleSubmit = (msg, severity) => {
  //   setSnackbarSeverity(severity);
  //   setSnackbarMessage(msg);
  //   setSnackbarOpen(true);
  //   fetchStudent();
  // };

  const handleSubmit = (msg, severity) => {
  studentCache.current.clear(); // ← add this so edited data doesn't stay stale
  setSnackbarSeverity(severity);
  setSnackbarMessage(msg);
  setSnackbarOpen(true);
  fetchStudent({ forceRefresh: true }); // a student was just added/edited — bust the page cache too
};

  //End
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleGradeChange = (event) => {
    setSelectedGrade(event.target.value);
  };

  const handleSectionChange = (event) => {
    setSelectedSection(event.target.value);
  };

  //  const academicYearId = 1;
  //Done by Simran
  //Added fetchStudent function and useEffect
  useEffect(() => {
    fetchStudent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [academicYearId, appliedGradeId, appliedSectionId, page, rowsPerPage, debouncedSearchQuery, sortConfig]);

  // Holds full page results already fetched this session, keyed by the
  // exact filter+page combo, so navigating back to a page already seen
  // skips the network entirely. Cleared whenever a student is added/edited
  // so it can never serve stale data afterward.
  const pageCacheRef = React.useRef(new Map());
  const PAGE_CACHE_TTL_MS = 60000; // bounds staleness from other users'/tabs' concurrent changes
  // On a cache miss, fetch this many pages' worth in one request instead of
  // just the one requested — sequential "next page" clicks then land in the
  // same already-fetched block and cost zero additional DB calls. Still
  // bounded (e.g. 3 * 25 = 75 rows max), nowhere near "load everything".
  const PAGE_BLOCK_SIZE = 3;
  // The count query is a second full pass over the filter (with decrypts if
  // searching); skip it when only the page/rowsPerPage changed within the
  // same filter/search scope, since the total can't have changed from that.
  const lastCountFilterKeyRef = React.useRef(null);

  const pageCacheKey = (filterKey, pageNum, size) => `${filterKey}|${pageNum}|${size}`;

  // Search refinement cache: when a search (within the current grade/
  // section filter) returns its *entire* matching set in one go, it's
  // remembered here. Typing more characters only ever narrows the match,
  // so as long as grade/section haven't changed and the new search term
  // still contains the cached one, we can filter that already-fetched
  // complete set in the browser instead of asking the server again —
  // collapsing several keystroke-pause calls into a single one.
  const fullSearchCacheRef = React.useRef({ filterScopeKey: null, term: null, rows: [] });

  // Mirrors fn_get_students_details_by_academic_year_id's search predicate:
  // every word in the term must match SOME field, not necessarily the same
  // one (so "k j" matches first_name "K" + last_name "J"), not the whole
  // phrase as one literal substring against a single field. Broader than
  // Sales' search — this can match unrelated students when siblings share a
  // parent's email address, which is a known, accepted tradeoff here.
  const matchesStudentSearchTerm = (row, term) => {
    const words = term.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const fields = [
      String(row.student_id ?? "").toLowerCase(),
      (row.first_name || "").toLowerCase(),
      (row.last_name || "").toLowerCase(),
      (row.father_name || "").toLowerCase(),
      (row.mother_name || "").toLowerCase(),
      (row.email_id || "").toLowerCase(),
      String(row.contact_no ?? "").toLowerCase(),
      String(row.fee_slab_id ?? "").toLowerCase(),
    ];
    return words.every((word) => fields.some((field) => field.includes(word)));
  };

  const fetchStudent = async (options = {}) => {
    // On first mount (and briefly after any hard refresh), academicYearId
    // is still "" — Layout resolves it asynchronously and only then sets
    // the real value. Fetching with the empty placeholder would render an
    // empty/wrong result that then gets replaced the moment the real year
    // arrives, which is exactly what shows up as a flicker. Skip the fetch
    // entirely until there's a real year to fetch for.
    if (!academicYearId) {
      return;
    }
    // Also scopes the search-refinement cache below — a different academic
    // year or sort is a different result set entirely, so it can't be
    // reused across years/sorts. academicYearId has to be in here too:
    // switching years doesn't clear debouncedSearchQuery, so without it the
    // refinement shortcut below would see the same search term and
    // grade/section/sort, judge the scope "unchanged", and silently serve
    // back the previous year's cached rows for the new year.
    const filterScopeKey = `${academicYearId}|${appliedGradeId}|${appliedSectionId}|${sortConfig.key}|${sortConfig.direction}`;
    const filterKey = `${filterScopeKey}|${debouncedSearchQuery}`;
    const cacheKey = pageCacheKey(filterKey, page, rowsPerPage);
    const forceRefresh = options.forceRefresh === true;

    if (forceRefresh) {
      pageCacheRef.current.clear();
      fullSearchCacheRef.current = { filterScopeKey: null, term: null, rows: [] };
    } else {
      const cached = pageCacheRef.current.get(cacheKey);
      if (cached && Date.now() - cached.timestamp < PAGE_CACHE_TTL_MS) {
        setRows(cached.rows);
        setTotalCount(cached.total);
        return; // served from memory — no request made
      }

      // Can this search be answered by narrowing an already-complete set?
      const priorCache = fullSearchCacheRef.current;
      if (
        debouncedSearchQuery &&
        priorCache.filterScopeKey === filterScopeKey &&
        priorCache.term !== null &&
        debouncedSearchQuery.toLowerCase().includes(priorCache.term.toLowerCase())
      ) {
        const filtered = priorCache.rows.filter((row) =>
          matchesStudentSearchTerm(row, debouncedSearchQuery)
        );
        const pageRows = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setRows(pageRows);
        setTotalCount(filtered.length);
        // The filtered set is itself complete (a subset of a complete set
        // matching a more specific term), so refinement can keep chaining.
        fullSearchCacheRef.current = { filterScopeKey, term: debouncedSearchQuery, rows: filtered };
        lastCountFilterKeyRef.current = filterKey;
        pageCacheRef.current.set(cacheKey, {
          rows: pageRows,
          total: filtered.length,
          timestamp: Date.now(),
        });
        return; // served from memory — no request made
      }
    }

    setLoading(true); // Set loading state
    try {
      const skipCount = !forceRefresh && lastCountFilterKeyRef.current === filterKey;

      // Align the fetch to a block boundary and request the whole block.
      const blockIndex = Math.floor(page / PAGE_BLOCK_SIZE);
      const blockStartPage = blockIndex * PAGE_BLOCK_SIZE;
      const blockRowsPerPage = PAGE_BLOCK_SIZE * rowsPerPage;

      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/student/getstudents",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            page: blockIndex,
            rowsPerPage: blockRowsPerPage,
            search: debouncedSearchQuery || undefined,
            grade_id: appliedGradeId || undefined,
            section_id: appliedSectionId || undefined,
            orderBy: sortConfig.key,
            order: sortConfig.direction,
            skipCount,
          }),
        },
      );
      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const blockRows = Array.isArray(data?.rows) ? data.rows : [];
      // total is null when skipCount was requested — keep the existing
      // totalCount rather than clobbering it with nothing.
      const effectiveTotal =
        data?.total !== null && data?.total !== undefined ? data.total : totalCount;
      if (data?.total !== null && data?.total !== undefined) {
        setTotalCount(data.total);
      }

      // Slice the block into individual pages and cache each one, so the
      // existing per-page lookup above transparently hits these on the
      // next few "next page" clicks.
      for (let i = 0; i < PAGE_BLOCK_SIZE; i++) {
        const subPage = blockStartPage + i;
        const subRows = blockRows.slice(i * rowsPerPage, (i + 1) * rowsPerPage);
        pageCacheRef.current.set(pageCacheKey(filterKey, subPage, rowsPerPage), {
          rows: subRows,
          total: effectiveTotal,
          timestamp: Date.now(),
        });
      }

      const requestedPageEntry = pageCacheRef.current.get(cacheKey);
      setRows(requestedPageEntry ? requestedPageEntry.rows : []);

      // If this fetch turned out to cover the search's entire matching set
      // (small enough to fit in one block), remember it so further typing
      // can be refined client-side instead of hitting the server. Only
      // touch this when we have a fresh, accurate total (skipCount means we
      // didn't recompute it this round, so leave it as-is).
      if (data?.total !== null && data?.total !== undefined) {
        if (debouncedSearchQuery && data.total <= blockRowsPerPage) {
          fullSearchCacheRef.current = { filterScopeKey, term: debouncedSearchQuery, rows: blockRows };
        } else {
          fullSearchCacheRef.current = { filterScopeKey: null, term: null, rows: [] };
        }
      }
      if (!skipCount) {
        lastCountFilterKeyRef.current = filterKey;
      }
    } catch (error) {
      console.error("Error fetching fee payment data:", error);
      setRows([]);
      setTotalCount(0);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // "Download Report" needs every matching student, not just the current
  // page, so it fetches separately rather than reusing the paginated `rows`
  // state.
  const fetchAllStudentsForReport = async () => {
    const response = await fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/student/getstudents",
      {
        method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          academic_year_id: academicYearId,
          search: debouncedSearchQuery || undefined,
          grade_id: appliedGradeId || undefined,
          section_id: appliedSectionId || undefined,
          orderBy: sortConfig.key,
          order: sortConfig.direction,
          exportAll: true,
        }),
      },
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return Array.isArray(data?.rows) ? data.rows : [];
  };
  //End

  // Both search and grade/section filters are explicit now: typing or
  // picking a grade/section does nothing on its own. Only clicking Go (or
  // pressing Enter in the search box) applies whichever combination is
  // currently set — search alone, grade/section alone, or all together —
  // in a single fetch.
  const handleApplyFilters = () => {
    setDebouncedSearchQuery(searchQuery.trim());
    setAppliedGradeId(selectedGrade);
    setAppliedSectionId(selectedSection);
    setPage(0); // Reset to first page since the filtered result set changes
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApplyFilters();
    }
  };

  // Clears the search box AND applies that immediately (rather than
  // waiting for Go/Enter) — the whole point of the clear button is to get
  // straight back to the unfiltered-by-search list without an extra click.
  // Grade/section stay as they were; only the search scope resets.
  const handleClearSearch = () => {
    setSearchQuery("");
    setDebouncedSearchQuery("");
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // const handleRowClick = (row) => {
  //   const studentId = row.student_id;
  //   axios
  //     .get(
  //       process.env.REACT_APP_JHS_DEVELOPMENT +
  //         `/student/getstudentdetails?student_id=${studentId}`,
  //       { withCredentials: "true" },
  //     )
  //     .then((response) => {
  //       setSelectedStudent(response.data);
  //       setIsModalOpen(true);
  //       setOldPaymentData(response.data);
  //       console.log("Old Data", response.data);

  //       // Create memoized maps for O(1) lookups instead of O(n) .find() operations
  //       const gradeMap = new Map();
  //       grades.forEach((grade) => gradeMap.set(grade.grade_id, grade.grade_name));

  //       const sectionMap = new Map();
  //       sections.forEach((section) => sectionMap.set(section.section_id, section.section_name));

  //       const feesSlabMap = new Map();
  //       feeSlab.forEach((slab) => feesSlabMap.set(slab.fees_slab_id, slab.fees_slab));

  //       const transportSlabMap = new Map();
  //       transportFees.forEach((slab) => transportSlabMap.set(slab.transport_slab_id, slab.transport_slab_name));

  //       // Use fast map lookups
  //       setGradeName(gradeMap.get(response.data.grade_id) || "");
  //       setGradeAdmissionName(gradeMap.get(response.data.grade_of_admission) || "");
  //       setSectionName(sectionMap.get(response.data.section_id) || "No section available");
  //       setFeesSlabName(feesSlabMap.get(response.data.fee_slab_id) || "");
  //       setTransportSlab(transportSlabMap.get(response.data.transport_slab_id) || "");
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };

  const handleRowClick = (row) => {
  // ↓ open modal immediately — no waiting
  setSelectedStudent(row);
  setIsModalOpen(true);

  // ↓ use cache if already fetched
  if (studentCache.current.has(row.student_id)) {
    const cached = studentCache.current.get(row.student_id);
    setSelectedStudent(cached);
    setOldPaymentData(cached);
    setGradeName(gradeMap.current.get(cached.grade_id) || "");
    setGradeAdmissionName(gradeMap.current.get(cached.grade_of_admission) || "");
    setSectionName(sectionMap.current.get(cached.section_id) || "No section available");
    setFeesSlabName(feesSlabMap.current.get(cached.fee_slab_id) || "");
    setTransportSlab(transportMap.current.get(cached.transport_slab_id) || "");
    return;
  }

  axios
    .get(
      process.env.REACT_APP_JHS_DEVELOPMENT + `/student/getstudentdetails?student_id=${row.student_id}`,
      { withCredentials: true }
    )
    .then((response) => {
      studentCache.current.set(row.student_id, response.data); // ← cache it
      setSelectedStudent(response.data);
      setOldPaymentData(response.data);
      setGradeName(gradeMap.current.get(response.data.grade_id) || "");
      setGradeAdmissionName(gradeMap.current.get(response.data.grade_of_admission) || "");
      setSectionName(sectionMap.current.get(response.data.section_id) || "No section available");
      setFeesSlabName(feesSlabMap.current.get(response.data.fee_slab_id) || "");
      setTransportSlab(transportMap.current.get(response.data.transport_slab_id) || "");
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  //Added Sorting to the table

  //Start
  // Sorting now happens server-side, across every matching student — not
  // just the page on screen. A new sort is effectively a different result
  // order entirely, so this resets to page 0 (staying on "page 3" from the
  // old order wouldn't line up with anything meaningful in the new one).
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    setPage(0);
  };

  // Search, grade/section filtering, sorting, and pagination all now
  // happen server-side (see fetchStudent) — `rows` already holds exactly
  // one correctly ordered page, so no client-side re-sort here. Sorting by
  // an encrypted column (name/email/contact) costs the same as searching
  // does — the DB has to decrypt the whole matching set before it can
  // order it — but that's the same tradeoff already accepted for search.
  const paginatedRows = rows;

  //End

  const generateExcel = async (otp) => {
    //   let wb = XLSX.utils.book_new();
    //   let ws = XLSX.utils.json_to_sheet(allRows);

    //   // Add sheet protection
    // ws["!protect"] = {
    //   password: "jhs1234",
    // };

    // const columnsToExclude = [''];

    //   XLSX.utils.book_append_sheet(wb,ws,"Student_Record",true);
    //   const base64 = XLSX.write(wb, { type: "base64" });
    // 1. Filter out unwanted columns

    const columnsToExclude = ["role_id", "role_name"];

    // The report covers every matching student, not just the page
    // currently displayed, so it fetches the full (unpaginated) result set
    // on demand rather than reusing the paginated `rows` state.
    let reportRows;
    try {
      reportRows = await fetchAllStudentsForReport();
    } catch (error) {
      console.error("Error fetching student data for report:", error);
      return;
    }

    const filteredData = reportRows.map((row) => {
      const newRow = { ...row };
      columnsToExclude.forEach((col) => {
        delete newRow[col];
      });
      return newRow;
    });

    console.log("Filtered data =", filteredData);

    // 2. Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    worksheet["!protect"] = { password: "" + otp };

    // 3. Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "StudentList", true);

    // // 4. Export the workbook
    const base64 = XLSX.write(workbook, { type: "base64" });

    setDownloadUrl(
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        base64,
    );
    const link = document.createElement("a");
    link.href =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
      base64;
    link.download = "Student_List"; // Optional: custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCloseModal = () => {
    setIsOtpModalOpen(false);

    setSelectedStudent(null);
    setIsModalOpen(false);

    // Reset all states related to OTP input, verification, and timers
    setOtp(["", "", "", "", "", ""]); // Reset OTP fields
    setVerifyOTPMsg(""); // Clear any verification message
    setResendCount(0); // Reset resend count
    setResendTimer(600); // Reset resend timer
    setCanResend(true); // Disable resend button
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Focus on the next input
      if (value !== "" && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      // Focus on the previous input
      if (value === "" && index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) {
          prevInput.focus(); // Ensure focus happens only if the previous input exists
        }
      }
    }
  };

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  const handleGetOtp = async () => {
    setIsOtpModalOpen(true);
    try {
      // Assuming you have a way to get the oldPaymentDetails

      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/send-otp/getOtpForDownloadReport",
        {
          email,
          userMail,
          userId: userId,
          created_by: userId,
        },
        { withCredentials: "true" },
      );

      if (response.data.otp) {
        setBackendOtp(response.data.otp);
        setOtpSent(true);
        setResendTimer(600);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        setIsOtpModalOpen(true); // Open OTP modal
      }
    } catch (error) {
      if (error.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // ✅ Fix: Ensure correct spelling
        return;
      }
      setTimeout(() => {}, 2000);
    }
  };

  const [downloadRequested, setDownloadRequested] = useState(false); // Flag to indicate download requested

  const handleGetOtpForDownload = () => {
    setDownloadRequested(true); // Mark that download was requested
    handleGetOtp(); // Trigger OTP modal
  };

  const handleDownloadReportButtonClick = () => {
    if (!downloadReportEnabled) {
      setSnackbarSeverity("success");
      setSnackbarMessage(
        "Download Report is currently disabled.",
      );
      setSnackbarOpen(true);
      return;
    }
    handleGetOtpForDownload();
  };

  const handleVerifyOtp = (event) => {
    event.preventDefault();
    const enteredOtp = otp.join("");

    if (!enteredOtp) {
      setVerifyOTPMsg("Please enter the OTP");
      return;
    }

    if (enteredOtp === backendOtp) {
      setVerifyOTPMsg("OTP Verified Successfully");
      setIsOtpModalOpen(false);
      setOtp(["", "", "", "", "", ""]);
      setVerifyOTPMsg("");
      setResendCount(0);
      setResendTimer(600);
      setCanResend(true);

      if (downloadRequested) {
        generateExcel(backendOtp); // Trigger download only after OTP is verified
        setDownloadRequested(false); // Reset the flag
      }
    } else {
      setVerifyOTPMsg("Invalid OTP");
    }
  };

  // const downloadExcelReport = () => {
  //   generateExcel();
  //   // const link = document.createElement("a");
  //   // link.href = downloadUrl;
  //   // link.download = "Student_List.xlsx"; // Optional: custom filename
  //   // document.body.appendChild(link);
  //   // link.click();
  //   // document.body.removeChild(link);
  // };

  // Add this useEffect to handle the countdown timer
  useEffect(() => {
    let intervalId;

    if (isOtpModalOpen && resendTimer > 0 && !canResend) {
      intervalId = setInterval(() => {
        setResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            clearInterval(intervalId);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isOtpModalOpen, canResend, resendTimer]);

  const handleResendOtp = () => {
    if (canResend && resendCount < 3) {
      setResendCount((prev) => prev + 1);
      handleGetOtp(); // Triggers OTP generation and email
      setCanResend(false); // Disable until timer ends
      setResendTimer(600); // Restart the timer
    } else {
      setVerifyOTPMsg(
        "You have reached the maximum number of resend attempts.",
      );
    }
  };

  return (
    <>
      <Layout />

      <div>
        <h1 className="title">Manage Students</h1>
      </div>

      <Container>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", marginBottom: "4px",}}>
            {/* updated code */}
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              placeholder="Search..."
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyDown}
              size="small"
              style={{ marginBottom: "0", border: "none", marginRight: "10px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      type="button"
                      sx={{ p: "10px" }}
                      aria-label="search"
                      onClick={handleApplyFilters}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: searchQuery ? (
                  <InputAdornment position="end">
                    <IconButton
                      type="button"
                      sx={{ p: "6px" }}
                      aria-label="clear search"
                      onClick={handleClearSearch}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            {/* Grade Select with filter */}
            <Box sx={{ minWidth: 265 }} style={{ marginRight: "10px" }}>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ grade_id: "", grade_name: "All" }, ...grades]}
                getOptionLabel={(option) => option.grade_name}
                isOptionEqualToValue={(option, value) => option.grade_id === value.grade_id}
                value={
                  selectedGrade === ""
                    ? { grade_id: "", grade_name: "All" }
                    : grades.find((g) => g.grade_id === selectedGrade) || null
                }
                onChange={(event, newValue) => {
                  handleGradeChange({
                    target: { value: newValue ? newValue.grade_id : "" },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grade"
                    inputProps={{
                      ...params.inputProps,
                      style: {
                        textOverflow: "clip",
                      },
                    }}
                  />
                )}
                // Enable filtering as user types
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.grade_name
                      .toLowerCase()
                      .includes(inputValue.toLowerCase()),
                  );
                }}
                noOptionsText="No matching grades"
                // Ensure the dropdown doesn't auto-open on focus
                openOnFocus={false}
                // Optional: Clear the selection with a button
                clearOnEscape
                disableClearable
              />
            </Box>
            <Box sx={{ minWidth: 100 }} style={{ marginRight: "10px" }}>
              <FormControl fullWidth size="small">
                <InputLabel id="section-select-label" shrink>Section</InputLabel>
                <Select
                  labelId="section-select-label"
                  id="section-select"
                  value={selectedSection}
                  label="Section"
                  onChange={handleSectionChange}
                  displayEmpty
                >
                  <MenuItem value="">All</MenuItem>
                  {sections.map((sections) => (
                    <MenuItem
                      key={sections.section_id}
                      value={sections.section_id}
                    >
                      {sections.section_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Button
              onClick={handleApplyFilters}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "10px",
                minWidth: "auto",
                paddingTop: "6px",
                paddingBottom: "6px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              Go
            </Button>
          </div>
          <div className="user_mngmt_add_delete_container">
            <Button
              style={{
                color: "#fff",
                background: "#0A64A2",
                marginRight: "5px",
              }}
              onClick={() => setIsModalOpen(true)}
            >
              Add Student
            </Button>
            <Button
              className="fees_report_btn"
              variant="contained"
              onClick={handleDownloadReportButtonClick}
              startIcon={<DownloadIcon />}
              sx={
                !downloadReportEnabled
                  ? {
                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                      color: "rgba(0, 0, 0, 0.26)",
                      boxShadow: "none",
                      // cursor: "not-allowed",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.12)",
                        boxShadow: "none",
                      },
                    }
                  : undefined
              }
            >
              Download Report
            </Button>
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <TableContainer component={Paper} style={{ position: "relative" }}>
          {/* Small, out-of-the-way "still working" cue — rows below stay
              at full opacity (no dim/blur) the whole time, this is the
              only loading signal for a refetch (sort, page change,
              filter). */}
          {loading && paginatedRows.length > 0 && (
            <CircularProgress
              size={20}
              style={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
            />
          )}
          <Table sx={{ minWidth: 600 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "student_id"}
                    direction={
                      sortConfig.key === "student_id"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("student_id")}
                    style={{
                      color:
                        sortConfig.key === "student_id" ? "white" : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Student ID
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "first_name"}
                    direction={
                      sortConfig.key === "first_name"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("first_name")}
                    style={{
                      color:
                        sortConfig.key === "first_name" ? "white" : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Student Name
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "father_name"}
                    direction={
                      sortConfig.key === "father_name"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("father_name")}
                    style={{
                      color:
                        sortConfig.key === "father_name" ? "white" : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Parent Name
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "email_id"}
                    direction={
                      sortConfig.key === "email_id"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("email_id")}
                    style={{
                      color:
                        sortConfig.key === "email_id" ? "white" : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Email ID
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "contact_no"}
                    direction={
                      sortConfig.key === "contact_no"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("contact_no")}
                    style={{
                      color:
                        sortConfig.key === "contact_no" ? "white" : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Contact No
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "profile_completion_percentage"}
                    direction={
                      sortConfig.key === "profile_completion_percentage"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("profile_completion_percentage")}
                    style={{
                      color:
                        sortConfig.key === "profile_completion_percentage"
                          ? "white"
                          : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Profile Completion (%)
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={sortConfig.key === "paid_percentage"}
                    direction={
                      sortConfig.key === "paid_percentage"
                        ? sortConfig.direction
                        : "asc"
                    }
                    onClick={() => handleSort("paid_percentage")}
                    style={{
                      color:
                        sortConfig.key === "paid_percentage"
                          ? "white"
                          : "inherit",
                      textAlign: "center",
                      marginLeft: "30px",
                    }}
                  >
                    Fees Paid (%){" "}
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            {/* Keep showing the previous page's rows (at full opacity — no
                dim/blur) while a refetch is in flight, instead of blanking
                the whole table out to a spinner — that swap-to-blank-and-back
                is what reads as a flicker on fast requests (cache hits, quick
                network responses). The small corner spinner above is the
                only loading cue once there's something on screen; this
                full-table spinner only shows on a genuine first load. */}
            {(loading || !academicYearId) && paginatedRows.length === 0 ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {/* highlighted Part */}
                {paginatedRows.map((row) => (
                  <StyledTableRow
                    key={row.student_id}
                    onClick={() => handleRowClick(row)}
                    sx={{ backgroundColor: row.rte ? "#ffff88" : "inherit" }}
                  >
                    <StyledTableCell
                      component="th"
                      scope="row"
                      style={{ textAlign: "center" }}
                    >
                      {row.student_id}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {row.first_name + " " + row.last_name}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {row.father_name
                        ? row.father_name
                        : row.mother_name || row.guardian_name}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {row.email_id}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {row.contact_no}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {row.profile_completion_percentage} %
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "center", padding: "0px" }}
                    >
                      {row.paid_percentage + "%"}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          style={{ background: "#0A64A2", color: "#fff", width: "100%" }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <div
          style={{
            padding: 20,
            background: "#fff",
            margin: "5% auto",
            width: "50%",
          }}
        >
          <StudentForm
            studentData={selectedStudent}
            onClose={handleCloseModal}
            handleSubmit={handleSubmit}
            oldPaymentData={oldPaymentData}
            setIsModalOpen={setIsModalOpen}
            academicYearId={academicYearId}
            gradeName={gradeName}
            setGradeName={setGradeName}
            sectionName={sectionName}
            feesSlabName={feesSlabName}
            gradeAdmissionName={gradeAdmissionName}
            userId={userId}
            userMail={userMail}
            transportSlab={transportSlab}
            grades={grades}              
            gradeAdmission={gradeAdmission}  
            sections={sections}         
            feeSlab={feeSlab}            
            transportFees={transportFees} 
            // feeSlab={feeSlab}
            // setFeeSlab={setFeeSlab}
          />
        </div>
      </Modal>
      <Snackbar
        style={{
          position: "absolute",
          top: "90%", // Position from the top, 50% of the container height
          left: "50%", // Position from the left, 50% of the container width
          transform: "translate(-50%, -50%)", // Adjust the positioning to center it
        }}
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert elevation={6} variant="filled" severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
        <Box className="modalStyle">
          {/* Close Button in the top-right corner */}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            style={{ position: "absolute", top: 7, right: 10 }}
          >
            <CloseIcon />
          </IconButton>

          <h3 className="enter-otp">Enter OTP</h3>
          <Divider className="divider" />
          {verifyOTPMsg && <p className="invalid-otp">{verifyOTPMsg}</p>}

          {/* OTP Input Boxes */}
          <div className="otp-container">
            {otp.map((data, index) => (
              <TextField
                autoFocus={index === 0}
                key={index}
                value={data}
                onChange={(e) => handleOtpChange(e, index)}
                inputProps={{
                  maxLength: 1,
                  id: `otp-input-${index}`, // Set id for focus management
                  style: {
                    textAlign: "center", // Center the text inside
                    fontSize: "17px", // Font size adjustment
                    width: "40px", // Set width and height equal to make it square
                    height: "40px", // Set width and height equal to make it square
                    padding: 0, // Remove default padding
                    boxSizing: "border-box", // Ensure borders don't affect the box size
                  },
                }}
                InputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: 0, // Remove extra padding to keep it square
                  },
                }}
              />
            ))}
          </div>

          {/* Verify and Resend OTP Message */}
          <div className="otp-btn-container">
            {/* Resend OTP Control */}
            {canResend ? (
              <p
                className="resend-otp"
                style={{ color: "green", cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                Resend OTP {resendCount}/3
              </p>
            ) : (
              <p style={{ color: "red" }}>
                Resend OTP in {formatTime(resendTimer)}
              </p>
            )}

            <Button
              variant="contained"
              onClick={handleVerifyOtp} // Use handleVerifyOtp for verification
              className="verify-btn"
            >
              Verify
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
